import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IListingSortOption } from '@df/catalog-ui/listing/sort/listing-sort';
import { ListingSortComponentDef } from '@df/catalog-ui/listing/sort/listing-sort.component.def';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import findIndex from 'lodash-es/findIndex';
import { Swiper } from 'swiper';
import { SwiperEvents } from 'swiper/types';
@Component({
    selector: 'listing-sort',
    templateUrl: './listing-sort.html',
    styleUrls: ['./listing-sort.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, CarouselModule, IfSizeDirective]
})
export class ListingSortComponent extends ListingSortComponentDef {
    swiper?: Swiper;
    onAfterInit(eventParams: Parameters<SwiperEvents['afterInit']>) {
        this.swiper = eventParams[0];
        if (this.swiper) {
            const options = this.sort.getOptions();
            const activeIndex = findIndex(options, i => !!i.active);
            if (activeIndex > -1) {
                this.swiper.slideTo(activeIndex);
            }
        }
    }
    select(option: IListingSortOption, index: number): void {
        this.sort.by(option);
        if (this.swiper) {
            this.swiper.slideTo(index);
        }
        this.detectChanges();
    }
}
